import React from "react";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router";
import Button from "../components/Button";
import StrapiImage from "./StrapiImage";

const WineBlock = (props) => {
  const history = useHistory();
  const { description, wine_art, wine_name, cellar_wines } = props.wineInfo;
  if (!props.wineInfo.wine_name || !props.wineInfo.wine_art) {
    return null;
  }

  const shortenedDesc = () => {
    if (!description) {
      return null;
    }
    const length = 120;
    const desc = description;
    const trimmedDesc = desc.substring(0, Math.min(length, desc.length));
    if (description.length < length) {
      return description;
    } else {
      return trimmedDesc + "...";
    }
  };
  const hyphenWineName = wine_name.split(" ").join("-").toLowerCase();

  const renderCellarVintages = () => {
    if (!cellar_wines || cellar_wines.length === 0) {
      return null;
    }
    const vintages = cellar_wines
      .map((wine) => wine?.vintage ?? wine?.fields?.vintage)
      .filter((vintage) => vintage != null && vintage !== "");
    if (vintages.length === 0) {
      return null;
    }
    return (
      <div className="wine-block__cellar">
        <p className="i b mb-0">From the Cellar vintages:</p>
        {vintages.join(", ")}
      </div>
    );
  };

  return (
    <div className="wine-block">
      <div className="wine-block__content">
        <img
          className="wine-art pointer"
          onClick={() => history.push("/" + hyphenWineName)}
          src={StrapiImage(wine_art)}
          alt={wine_name + " art"}
        />
        <div className="wine-block__body">
          <h3 className="wine-block__name">{wine_name}</h3>
          <p className="wine-description">{shortenedDesc()}</p>
          {renderCellarVintages()}
          <div className="wine-block__button-wrap">
            <Button
              href="https://auburnroadvineyards.orderport.net/wines/Available-Wines"
              type="secondary"
              small
              external
            >
              buy now
            </Button>
            <Button
              onClick={() => history.push("/" + hyphenWineName)}
              type="plain"
              small
            >
              learn more
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withRouter(WineBlock);
